import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetTranslationCoverageV1Response } from './get-translation-coverage-v1-response';
import { getTranslationCoverageV1ResponseSchema } from './get-translation-coverage-v1-response';

export async function getTranslationCoverageV1Api(): Promise<
  IValidatedResponse<IGetTranslationCoverageV1Response>
> {
  return getRequest<IGetTranslationCoverageV1Response>({
    path: '/sys/challenges/translation-coverage/v1',
    schema: getTranslationCoverageV1ResponseSchema,
  });
}
